import SEO from '../components/SEO';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  return (
    <div className="bg-slate-50/60 py-12 sm:py-20">
      <SEO
        title="Kontakt - Power-Multiservice"
        description="Kontakt Power-Multiservice i Nørre Aaby på tlf. 31 68 67 64 eller send en besked. Vi står klar til at hjælpe med et tilbud."
        path="/kontakt"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Intro */}
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16 animate-fade-in-up">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-black text-slate-900 tracking-tight">
            Vi sidder klar til at hjælpe dig
          </h1>
          <p className="mt-3 text-base sm:text-lg text-slate-600 leading-relaxed">
            Har du spørgsmål til vores rengøringsydelser, eller ønsker du et uforpligtende tilbud på privat- eller erhvervsrengøring? Ring til os eller udfyld formularen nedenfor.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
          
          {/* Left Column: Direct Info Cards */}
          <div className="lg:col-span-5 space-y-6 animate-fade-in-up delay-100">
            
            {/* Info Card */}
            <div className="p-2 sm:p-4 space-y-6">
              <h2 className="text-xl font-bold text-slate-900 tracking-tight">
                Direkte kontakt
              </h2>

              <div className="space-y-6 text-sm text-slate-700">
                {/* Phone */}
                <div className="flex items-start gap-4">
                  <div className="text-slate-900 text-xl shrink-0 mt-0.5">
                    <i className="fa-solid fa-phone" aria-hidden="true" />
                  </div>
                  <div>
                    <a
                      href="tel:31686764"
                      className="text-base font-extrabold text-slate-900 hover:text-emerald-700 transition-colors whitespace-nowrap block"
                      aria-label="Ring 31 68 67 64"
                    >
                      31 68 67 64
                    </a>
                    <p className="text-xs text-slate-500 mt-0.5">Vi svarer hurtigt i dagtimerne</p>
                  </div>
                </div>

                {/* Email */}
                <div className="flex items-start gap-4">
                  <div className="text-slate-900 text-xl shrink-0 mt-0.5">
                    <i className="fa-solid fa-envelope" aria-hidden="true" />
                  </div>
                  <div>
                    <a
                      href="mailto:zokimaretic@gmail.com"
                      className="text-base font-bold text-slate-900 hover:text-emerald-700 transition-colors whitespace-nowrap block"
                      aria-label="Send mail til zokimaretic@gmail.com"
                    >
                      zokimaretic@gmail.com
                    </a>
                    <p className="text-xs text-slate-500 mt-0.5">Skriftlige henvendelser besvares hurtigt</p>
                  </div>
                </div>

                {/* Address & CVR */}
                <div className="flex items-start gap-4">
                  <div className="text-slate-900 text-xl shrink-0 mt-0.5">
                    <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  </div>
                  <div>
                    <p className="font-bold text-slate-900">Power-Multiservice</p>
                    <p className="text-slate-600 text-xs mt-0.5">Idrætsvej 1, 5580 Nørre Aaby</p>
                    <p className="text-slate-500 text-xs mt-1">CVR: 27253466</p>
                  </div>
                </div>
              </div>

              {/* Service Area */}
              <div className="pt-2">
                <div className="p-5 bg-white border border-slate-200 space-y-2">
                  <div className="flex items-center gap-2 text-slate-900 text-xs font-bold uppercase tracking-wider">
                    <span>Dækningsområde</span>
                  </div>
                  <p className="text-xs text-slate-600 leading-relaxed">
                    Vi udfører professionel rengøring for både private og virksomheder i Nørre Aaby, Middelfart, Fredericia, Odense og omkringliggende fynske/jyske områder.
                  </p>
                </div>
              </div>

            </div>

          </div>

          {/* Right Column: Webform */}
          <div className="lg:col-span-7">
            <ContactForm heading="Send os en besked" />
          </div>

        </div>

      </div>
    </div>
  );
}
